import { useQuery } from "@tanstack/react-query"

import i18n from "@/i18n/config"

import { publicApi } from "../apiClient"

interface InsuranceResponse {
  Success: boolean
  Name: string
  ShortDescription: string
  FullDescription: string
  CurrencySymbol: string
  Price: number
  ExistingPrice: number
  AnalyticsName: string
  AnalyticsId: string
}

export interface UseInsuranceOptions {
  resortId: number
  arrivalDate: string
  bookingLength: number
  productType: string
  birthDate: string
  firstName: string
  lastName: string
  cultureName: string
}

const useInsurance = (options: UseInsuranceOptions, enabled: boolean) => {
  return useQuery<InsuranceResponse, Error>({
    queryKey: ["insurance", options],
    queryFn: async () => {
      const response = await publicApi.get<InsuranceResponse>(
        "/common/insurance/get",
        {
          params: {
            ...options,
            insuranceType: "PLUS",
            includeTheft: 0,
          },
        }
      )

      if (!response.data.Success) {
        throw new Error(i18n.t("insuranceFetchError"))
      }

      return response.data
    },
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: 1,
  })
}

export default useInsurance
